<div class="purchase-options" *ngIf="content.isMembership">
  <!-- <div *ngIf="checkout.error">
    <aura-error-message [content]="checkout.error"></aura-error-message>
  </div> -->
  <!-- Moved the error message to top of the page -->
  <aura-divider [type]="'light'"></aura-divider>
  <form>
    <section>
      <section *ngFor="let option of content.options">
        <fieldset class="purchase-options__section">
          <legend class="purchase-options__title">
            {{ option.type.title }}
            <div class="purchase-options__subtitle">
              {{ option.type.subtitle }}
              {{ option.type.content }}
            </div>
          </legend>
          <div class="purchase-options__radio-button-wrapper">
            <div
              class="purchase-options__alignment"
              *ngFor="let currency of option.currencies; let i = index"
            >
              <input
                auraRadio
                type="radio"
                [name]="option.type.title.toLowerCase().replace(' ', '_')"
                [id]="'radio-' + option.membershipDetails[i].objectIndex"
                #item
                [value]="currency.value"
                (click)="selectOptions(item.value, option.membershipDetails[i])"
                auraRadioColor="primary"
              />
              <label
                [for]="'radio-' + option.membershipDetails[i].objectIndex"
                class="aura-radio-label"
              >
                {{ currency.value }} {{ currency.label }}
              </label>
            </div>
          </div>
          <aura-divider [type]="'light'"></aura-divider>
        </fieldset>
      </section>
      <aura-divider [type]="'light'"></aura-divider>

      <section class="purchase-options__total">
        <div class="purchase-options__details" *ngIf="!membership.selected">
          {{ content.total.title }}{{ content.total.subtitle }}
        </div>
        <div class="purchase-options__details" *ngIf="membership.selected">
          {{ content.total.title }}{{ membership.value }}
        </div>
      </section>

      <section class="purchase-options__action">
        <button
          auraButton
          [buttonSize]="'small'"
          [buttonColor]="'primary'"
          [buttonOutlineColor]="'primary'"
          [buttonDisabled]="!membership.selected"
          class="purchase-options__aura"
          [id]="content.action.id"
          (click)="onAddToCartClick()"
          type="button"
        >
          {{ content.action.label }}
        </button>
      </section>
    </section>
  </form>
</div>
